import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    teamList: [
        {
            name: 'Bar Tov',
            email: 'bar@ivycorn.com',
            addedDate: 'May 2, 2024',
            lastActive: 'May 2, 2024'
        },
        {
            name: 'Ajay Tank',
            email: 'ajay@ivycorn.com',
            addedDate: 'May 3, 2024',
            lastActive: 'May 3, 2024'
        }
    ]
}

const settingSlice = createSlice({
    name: 'setting',
    initialState,
    reducers: {
        setSettingTeamMember: (state, action) => {
            state.teamList = action.payload;
        },
    },
});

export const {
    setSettingTeamMember,
} = settingSlice.actions;

export default settingSlice.reducer;